export const ExpensesConfig = {
    name            : 'Expenses',
    icon            : 'i5-finance',
    image           : 'expenses',
    iconSvg         : 'isvg-view-expenses',
    url             : 'expenses',
    stringId        : 'expenses',
    description     : 'View and manage project-related expenses.',
    menuName        : 'Expenses',
    inheritance     : false,
    canBeInProject  : true,
}

export const PROJECT_EXPENSES_CONFIG = {
    ...ExpensesConfig,
    // key2: "newValue2",  // Replacing the value for key2
}
